var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "truck",
    clipPath: "url(#clip0_1035_7682)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M21.5542 21.3333V4H1.5542V21.3333H21.5542ZM21.5542 21.3333H30.8875V14.6667L26.8875 10.6667H21.5542V21.3333ZM10.8875 24.6667C10.8875 26.5076 9.39515 28 7.5542 28C5.71325 28 4.22087 26.5076 4.22087 24.6667C4.22087 22.8257 5.71325 21.3333 7.5542 21.3333C9.39515 21.3333 10.8875 22.8257 10.8875 24.6667ZM28.2209 24.6667C28.2209 26.5076 26.7285 28 24.8875 28C23.0466 28 21.5542 26.5076 21.5542 24.6667C21.5542 22.8257 23.0466 21.3333 24.8875 21.3333C26.7285 21.3333 28.2209 22.8257 28.2209 24.6667Z",
    stroke: "#0C4ACF",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1035_7682"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.220703)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.c7a1162b713c803c9ce891477dd092ea.svg";
export { ForwardRef as ReactComponent };